/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: ZhangLei
 * @Date: 2020-08-13 13:56:13
 * @LastEditTime: 2020-08-13 13:56:52
 * @LastEditors: ZhangLei
 * @Description:
 * @FilePath: /desktop/src/service/ConfigdomainService.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import request from "@/utils/request";
/**
 * Config列表
 */
export function getConfigData(Info) {
  return request({
    url:
      "/api/v1/configurations?size=" +
      Info.size +
      "&page=" +
      Info.page +
      "&filter=" +
      Info.filter +
      "&search=" +
      Info.search +
      "&order=" +
      Info.order,
    method: "GET"
  });
}
/*
 * 新建Config页面数据
 */
export function createConfig(data) {
  return request({
    url: "/api/v1/configurations",
    method: "POST",
    data: data
  });
}
/*
 * 编辑Config页面数据
 */
export function editConfig(data) {
  return request({
    url: "/api/v1/configurations/" + data.id,
    method: "PATCH",
    data: data.data
  });
}
/*
 * 获取Config数据详情
 */
export function getConfigInfo(id) {
  return request({
    url: "/api/v1/configurations/" + id,
    method: "GET"
  });
}
/*
 * 删除Config数据
 */
export function deleteConfig(id) {
  return request({
    url: "/api/v1/configurations/" + id,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/service/configService.js